if (!customElements.get("font-picker")) {
  customElements.define(
    "font-picker",
    class FontPicker extends HTMLElement {
      constructor() {
        super();
        //console.log('init font-picker')

        // Get references to the color input and font select elements
        this.colorInput = this.querySelector('input[type="color"]');
        this.fontSelect = this.querySelector("select");
        this.exampleText = this.querySelector(".js-font-example p");

        // Add event listeners to both elements
        this.colorInput.addEventListener("input", this.updateFontExample.bind(this));
        this.fontSelect.addEventListener(
          "change",
          this.updateFontExample.bind(this)
        );
      }

      connectedCallback() {
        // Retrieve and set input values from session storage
        this.updateFontExample();
      }

      // Function to update the font and color of the example text
      updateFontExample() {
        const color = this.colorInput.value;
        const font = this.fontSelect.value;

        this.exampleText.style.color = color;
        this.exampleText.className = font;
      }
    }
  );
}
